import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { BookingsSummaryAPI } from '@shared/types/api';

/**
 * Hook to fetch bookings summary per city per event day
 * Shows the last past event + 4 upcoming events
 */
export function useAdminBookingsSummary() {
  return useQuery({
    queryKey: ['admin-bookings-summary'],
    queryFn: async (): Promise<BookingsSummaryAPI.GetBookingsSummaryResponse> => {
      return api.get('/admin/bookings-summary');
    },
  });
}
